import { render, staticRenderFns } from "./AuthHeading.vue?vue&type=template&id=05612dfd&scoped=true&functional=true&"
import script from "./AuthHeading.vue?vue&type=script&lang=js&"
export * from "./AuthHeading.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  true,
  null,
  "05612dfd",
  null
  
)

export default component.exports